<div>
    <div *ngIf="sorts.length === 0" class='title-sort'>
        <span class="badge badge-dark">
            Sin Ordenamientos. 
            <span *ngIf="datatable.sortMaximos > 0">(Máximo {{datatable.sortMaximos}})</span>
        </span>
    </div>
    <ng-container *ngFor="let sort of sorts">
        <div 
            #sortDrop="ngbDropdown" 
            ngbDropdown
            display="dynamic"
            container="body"
            class='d-inline-block'
        >
            <span class="badge badge-pointer" [ngClass]="isAsc(sort) ? 'badge-primary' : 'badge-secondary'"
                id="menuSortLista" ngbDropdownToggle
            >{{sort.columna.nombre}} | {{isAsc(sort) ? 'Ascendente' : 'Descendente'}}
                <div ngbDropdownMenu aria-labelledby="menuSortLista" class='dropdown-sort'>
                    <button ngbDropdownItem 
                        *ngIf="hasToShow(sort.columna, sortData.CLASS_ASC)"
                        (click)="sortClickeado(sort.columna, sortData.CLASS_ASC)"
                    >
                        <strong>Ascendente</strong>
                    </button>
                    <button ngbDropdownItem 
                        *ngIf="hasToShow(sort.columna, sortData.CLASS_DESC)"
                        (click)="sortClickeado(sort.columna, sortData.CLASS_DESC)"
                    >
                        <strong>Descendente</strong>
                    </button>
                    <button ngbDropdownItem 
                        *ngIf="hasToShow(sort.columna, sortData.CLASS_NONE)" 
                        class='text-danger'
                        (click)="sortClickeado(sort.columna, sortData.CLASS_NONE)"
                    >
                        <strong>Remover</strong>
                    </button>
                </div>
            </span>
        </div>
    </ng-container>
</div>